import { DEFAULT_COLLECTION_FIELDS as fieldsInClassic } from './classic/predefinedCollection'
import { DEFAULT_COLLECTION_FIELDS as fieldsInStudio } from './studio/predefinedCollection'
import { EDITOR_TYPE } from '@wix/wix-data-client-common'

interface PresetSeoFields {
  description: string
  image: string
}

const classicSeoFields: PresetSeoFields = {
  description: fieldsInClassic.DESCRIPTION.fieldKey,
  image: fieldsInClassic.IMAGE.fieldKey,
}

const presetSeoFieldsByEditorType: Partial<
  Record<EDITOR_TYPE, PresetSeoFields>
> = {
  [EDITOR_TYPE.CLASSIC]: classicSeoFields,
  [EDITOR_TYPE.STUDIO]: {
    description: fieldsInStudio.SHORT_DESCRIPTION.fieldKey,
    image: fieldsInStudio.IMAGE.fieldKey,
  },
}

export const getPresetSeoFields = (
  editorType: EDITOR_TYPE,
): PresetSeoFields => {
  return presetSeoFieldsByEditorType[editorType] || classicSeoFields
}
